<template>
  <div :id="galleryId">
    <content-data v-for="(node, idx) in nodes" :key="idx" :node="node" />
  </div>
</template>

<script setup lang="ts">
import ContentData from '@/components/common/content-data.vue'

import type { ProductContentData } from '@/types/product'

interface Props {
  /** 「方案介紹」/「購買須知」靜態內容的 tree node 陣列 */
  nodes: ProductContentData[]
  /** PhotoSwipe gallery 容器 id，需在頁面中唯一，避免兩個 section 或與 preview 衝突 */
  galleryId: string
}

defineOptions({ name: 'ProductContentModalBody' })

const props = defineProps<Props>()

const { init } = useLightbox(props.galleryId)

onMounted(() => {
  init()
})
</script>

<style lang="scss" scoped></style>
